import React from 'react';

const SEV_CHIP = {
  critical: 'bg-rose-600 text-white', high: 'bg-orange-500 text-white',
  medium: 'bg-amber-400 text-amber-950', low: 'bg-slate-300 text-slate-700',
};
const STATES = [['open', 'Open'], ['in_progress', 'Being fixed'], ['fixed', 'Fixed'], ['accepted', 'Accepted as-is']];
const when = v => (v ? new Date(v).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '');

// every issue on this audit in one table: open first, then resolved
export const CourseQaIssueTable = ({ findings, stateOf, onState, onDetails }) => (
  <div className="bg-white border border-slate-200 rounded-md overflow-x-auto" data-testid="qa-issue-table">
    <table className="w-full text-left min-w-[760px]">
      <thead>
        <tr className="text-[10px] uppercase tracking-wider text-slate-400 border-b border-slate-200">
          <th className="px-3 py-2 font-semibold">Severity</th>
          <th className="px-2 py-2 font-semibold">Section</th>
          <th className="px-2 py-2 font-semibold">Issue</th>
          <th className="px-2 py-2 font-semibold">Check</th>
          <th className="px-2 py-2 font-semibold">Status</th>
          <th className="px-2 py-2 font-semibold">Last change</th>
          <th className="px-2 py-2" />
        </tr>
      </thead>
      <tbody>
        {findings.length === 0 && <tr><td colSpan={7} className="p-4 text-xs text-slate-400">No issues on this audit.</td></tr>}
        {findings.map(f => {
          const key = String(f.fid || f.rule);
          const st = stateOf(f);
          const resolved = ['fixed', 'accepted'].includes(st.state);
          return (
            <tr key={key} className={`border-b border-slate-50 last:border-0 align-top ${resolved ? 'bg-slate-50/60 text-slate-400' : ''}`}
              data-testid={`qa-table-row-${key}`}>
              <td className="px-3 py-2.5">
                <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-full ${resolved ? 'bg-emerald-100 text-emerald-700' : SEV_CHIP[f.severity]}`}>
                  {resolved ? 'Resolved' : f.severity}
                </span>
              </td>
              <td className="px-2 py-2.5 text-xs text-slate-600 w-40">{f.section}
                <span className="block text-[10px] text-slate-400">{f.visibility === 'record' ? 'Record (CMS)' : 'On the page'}</span>
                {f.section_type && <span className="block text-[9px] font-mono text-slate-400">{f.section_type}</span>}
              </td>
              <td className={`px-2 py-2.5 text-xs ${resolved ? 'line-through decoration-slate-300' : 'text-slate-800'}`}>{f.issue || f.name}</td>
              <td className="px-2 py-2.5 text-[11px] text-slate-600 w-48">{f.name}<span className="block text-[10px] text-slate-400">Rule {f.rule}</span></td>
              <td className="px-2 py-2.5 w-36">
                <select value={st.state || 'open'} onChange={e => onState(key, e.target.value)}
                  className="h-7 w-full text-[11px] border border-slate-200 rounded px-1.5 bg-white text-slate-700"
                  data-testid={`qa-table-state-${key}`}>
                  {STATES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </td>
              <td className="px-2 py-2.5 text-[10px] text-slate-400 w-32">{st.by ? `${st.by} · ${when(st.at)}` : '—'}</td>
              <td className="px-2 py-2.5 text-right w-16">
                <button onClick={() => onDetails(key)} className="text-[11px] text-blue-600 hover:underline" data-testid={`qa-table-details-${key}`}>Details</button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
